import { Navigate, useLocation, useParams } from "react-router-dom";
import { urls } from "../../../urls";
import { EditContract } from "./EditContract";

export const EditContractRoute = () => {
  const { contractId } = useParams();
  const location = useLocation();

  if (contractId) {
    return <Navigate to={`${urls.v2.contracts.edit.go(contractId)}${location.search}${location.hash}`} replace />;
  }

  return <EditContract />;
};
